import { render, staticRenderFns } from "./MediaCreate.vue?vue&type=template&id=6c0a3a68&scoped=true"
import script from "./MediaCreate.vue?vue&type=script&lang=js"
export * from "./MediaCreate.vue?vue&type=script&lang=js"
import style0 from "./MediaCreate.vue?vue&type=style&index=0&id=6c0a3a68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c0a3a68",
  null
  
)

export default component.exports